import { useCallback } from 'react';

import * as templateApi from 'api/templateApi';
import { useToast } from 'hooks/useToast';
import { useAppDispatch, useAppSelector } from 'store/hooks/useStore';
import {
  editActions,
  editSelectors,
} from 'store/reducers/apiKeyTemplateReducer/editSlice';
import { loaderActions } from 'store/reducers/loaderReducer/loaderSlice';
import { useListStore } from './useListStore';

export const useDeleteStore = () => {
  const dispatch = useAppDispatch();
  const toast = useToast();
  const { fetchApiKeyTemplates } = useListStore();
  const selectedApiKeyTemplate = useAppSelector(
    editSelectors.selectedApiKeyTemplate,
  );
  const isOpenModal = useAppSelector(editSelectors.isOpenModalDelete);

  const onCloseModal = useCallback(() => {
    dispatch(editActions.updateIsOpenModalDelete(false));
  }, [dispatch]);

  const onDeleteApiKeyTemplate = useCallback(() => {
    if (selectedApiKeyTemplate) {
      const apikeytemplateId = selectedApiKeyTemplate.id
        ? selectedApiKeyTemplate.id
        : 0;
      const requestDelete = async () => {
        dispatch(loaderActions.setLoading(true));
        dispatch(editActions.updateLoadingStatus(true));
        const result = await templateApi.deleteApiKeyTemplate(apikeytemplateId);
        if (result.ok) {
          toast({
            status: 'success',
            description: `APIキーテンプレートを削除しました。`,
          });

          onCloseModal();
          dispatch(editActions.modalOpened(null));
          void fetchApiKeyTemplates();
        } else {
          toast({
            status: 'error',
            description: `APIキーテンプレートの削除に失敗しました。`,
          });
        }
        dispatch(editActions.updateLoadingStatus(false));
        dispatch(loaderActions.setLoading(false));
      };

      requestDelete().catch(() => {
        toast({
          status: 'error',
          description: `APIキーテンプレートの削除に失敗しました。`,
        });
      });
    }
  }, [
    selectedApiKeyTemplate,
    toast,
    dispatch,
    onCloseModal,
    fetchApiKeyTemplates,
  ]);

  return {
    /** APIキーテンプレートの内容 */
    values: selectedApiKeyTemplate || {
      name: '',
      template: '',
    },
    /** APIキーテンプレートの削除 */
    onDeleteApiKeyTemplate,
    /** APIキーテンプレートの削除キャンセル */
    onCloseModal,
    /** APIキーテンプレート削除確認モーダルの表示状態 */
    isOpenModal,
  };
};
